import { render, staticRenderFns } from "./ClosingSlide.vue?vue&type=template&id=0df35c24&scoped=true&"
import script from "./ClosingSlide.vue?vue&type=script&lang=js&"
export * from "./ClosingSlide.vue?vue&type=script&lang=js&"
import style0 from "./ClosingSlide.vue?vue&type=style&index=0&id=0df35c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df35c24",
  null
  
)

export default component.exports